export default __webpack_public_path__ + "static/media/airstrapz-wht-3.59136f0e.png";